import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { SubCategory } from '../types/sub-category.type';
import { ADMIN_SUB_CATEGORIES_API_PATHS } from '../constants/sub-categories-api-paths.constants';

type UseArchiveSubCategoryResult = {
  archiveSubCategory: (subCategoryId: string) => Promise<SubCategory | null>;
  isSubmitting: boolean;
};

export function useArchiveSubCategory(): UseArchiveSubCategoryResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const archiveSubCategory = async (subCategoryId: string): Promise<SubCategory | null> => {
    setIsSubmitting(true);

    try {
      const archivedSubCategory = await HttpClient.delete<SubCategory>(
        ADMIN_SUB_CATEGORIES_API_PATHS.ARCHIVE_SUB_CATEGORY(subCategoryId)
      );

      enqueueSnackbar('Sous-rubrique archivée', { variant: 'success' });
      return archivedSubCategory;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(error, "Une erreur est survenue lors de l'archivage de la sous-rubrique"),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { archiveSubCategory, isSubmitting };
}
